type MinMaxInputNumbersType = {
  readonly [key: string]: number;
};

export enum FORM_NAMES {
  children = "children",
  numberOfGuests = "number_of_guests",
  timeArrival = "time_arrival",
  timeLeave = "time_leave",
}
export type FormTypes = {
  [FORM_NAMES.numberOfGuests]: number;
  [FORM_NAMES.children]: number;
  [FORM_NAMES.timeArrival]: {label: string; value: {h: number; m: number}};
  [FORM_NAMES.timeLeave]: {label: string; value: {h: number; m: number}};
  
//   [FORM_NAMES.timeArrival]: { label: string; value: { h: number; m: number } };
//   [FORM_NAMES.timeLeave]: { label: string; value: { h: number; m: number } };
};

export const MIN_INPUT_NUMBERS: MinMaxInputNumbersType = {
  [FORM_NAMES.children]: 0,
  [FORM_NAMES.numberOfGuests]: 1,
};

export const MAX_INPUT_NUMBERS: MinMaxInputNumbersType = {
  [FORM_NAMES.children]: 100,
  [FORM_NAMES.numberOfGuests]: 100,
};

